// AUTO-GENERATED - Do not manually edit this file
// This file is generated by scripts/devlink/config-generator/generate-props-config.js
import { FIELD_TYPES } from "../../../../../../constants/template-field-type";
export default {
    engineeringButtonText: {
        type: FIELD_TYPES.TEXT,
        label: "Engineering Button Text",
        translatable: true
    },
    engineeringTabH2: {
        type: FIELD_TYPES.TEXT,
        label: "Engineering Tab H 2",
        translatable: true
    },
    engineeringTabTagline: {
        type: FIELD_TYPES.TEXT,
        label: "Engineering Tab Tagline",
        translatable: true
    },
    engineeringUsecase1: {
        type: FIELD_TYPES.TEXT,
        label: "Engineering Usecase 1",
        translatable: true
    },
    engineeringUsecase2: {
        type: FIELD_TYPES.TEXT,
        label: "Engineering Usecase 2",
        translatable: true
    },
    engineeringUsecase3: {
        type: FIELD_TYPES.TEXT,
        label: "Engineering Usecase 3",
        translatable: true
    },
    engineeringUsecase4: {
        type: FIELD_TYPES.TEXT,
        label: "Engineering Usecase 4",
        translatable: true
    },
    engineeringUsecase5: {
        type: FIELD_TYPES.TEXT,
        label: "Engineering Usecase 5",
        translatable: true
    },
    engineeringUsecase6: {
        type: FIELD_TYPES.TEXT,
        label: "Engineering Usecase 6",
        translatable: true
    },
    itButtonText: {
        type: FIELD_TYPES.TEXT,
        label: "It Button Text",
        translatable: true
    },
    itSupportTabTitle: {
        type: FIELD_TYPES.TEXT,
        label: "It Support Tab Title",
        translatable: true
    },
    itTabH2: {
        type: FIELD_TYPES.TEXT,
        label: "It Tab H 2",
        translatable: true
    },
    itTabTagline: {
        type: FIELD_TYPES.TEXT,
        label: "It Tab Tagline",
        translatable: true
    },
    itUsecase1: {
        type: FIELD_TYPES.TEXT,
        label: "It Usecase 1",
        translatable: true
    },
    itUsecase2: {
        type: FIELD_TYPES.TEXT,
        label: "It Usecase 2",
        translatable: true
    },
    itUsecase3: {
        type: FIELD_TYPES.TEXT,
        label: "It Usecase 3",
        translatable: true
    },
    itUsecase4: {
        type: FIELD_TYPES.TEXT,
        label: "It Usecase 4",
        translatable: true
    },
    itUsecase5: {
        type: FIELD_TYPES.TEXT,
        label: "It Usecase 5",
        translatable: true
    },
    itUsecase6: {
        type: FIELD_TYPES.TEXT,
        label: "It Usecase 6",
        translatable: true
    },
    marketingButtonText: {
        type: FIELD_TYPES.TEXT,
        label: "Marketing Button Text",
        translatable: true
    },
    marketingTabH2: {
        type: FIELD_TYPES.TEXT,
        label: "Marketing Tab H 2",
        translatable: true
    },
    marketingTabTagline: {
        type: FIELD_TYPES.TEXT,
        label: "Marketing Tab Tagline",
        translatable: true
    },
    marketingTabTitle: {
        type: FIELD_TYPES.TEXT,
        label: "Marketing Tab Title",
        translatable: true
    },
    marketingUsecase1: {
        type: FIELD_TYPES.TEXT,
        label: "Marketing Usecase 1",
        translatable: true
    },
    marketingUsecase2: {
        type: FIELD_TYPES.TEXT,
        label: "Marketing Usecase 2",
        translatable: true
    },
    marketingUsecase3: {
        type: FIELD_TYPES.TEXT,
        label: "Marketing Usecase 3",
        translatable: true
    },
    marketingUsecase4: {
        type: FIELD_TYPES.TEXT,
        label: "Marketing Usecase 4",
        translatable: true
    },
    marketingUsecase5: {
        type: FIELD_TYPES.TEXT,
        label: "Marketing Usecase 5",
        translatable: true
    },
    pmoOperationsTagline: {
        type: FIELD_TYPES.TEXT,
        label: "Pmo Operations Tagline",
        translatable: true
    },
    pmoOpsButtonText: {
        type: FIELD_TYPES.TEXT,
        label: "Pmo Ops Button Text",
        translatable: true
    },
    pmoOpsTabH2: {
        type: FIELD_TYPES.TEXT,
        label: "Pmo Ops Tab H 2",
        translatable: true
    },
    pmoOpsTabTitle: {
        type: FIELD_TYPES.TEXT,
        label: "Pmo Ops Tab Title",
        translatable: true
    },
    pmoUsecase1: {
        type: FIELD_TYPES.TEXT,
        label: "Pmo Usecase 1",
        translatable: true
    },
    pmoUsecase2: {
        type: FIELD_TYPES.TEXT,
        label: "Pmo Usecase 2",
        translatable: true
    },
    pmoUsecase3: {
        type: FIELD_TYPES.TEXT,
        label: "Pmo Usecase 3",
        translatable: true
    },
    pmoUsecase4: {
        type: FIELD_TYPES.TEXT,
        label: "Pmo Usecase 4",
        translatable: true
    },
    pmoUsecase5: {
        type: FIELD_TYPES.TEXT,
        label: "Pmo Usecase 5",
        translatable: true
    },
    pmoUsecase6: {
        type: FIELD_TYPES.TEXT,
        label: "Pmo Usecase 6",
        translatable: true
    },
    productEngineeringTabTitle: {
        type: FIELD_TYPES.TEXT,
        label: "Product Engineering Tab Title",
        translatable: true
    },
    salesButtonText: {
        type: FIELD_TYPES.TEXT,
        label: "Sales Button Text",
        translatable: true
    },
    salesRevenueTabTitle: {
        type: FIELD_TYPES.TEXT,
        label: "Sales Revenue Tab Title",
        translatable: true
    },
    salesTabH2: {
        type: FIELD_TYPES.TEXT,
        label: "Sales Tab H 2",
        translatable: true
    },
    salesTabTagline: {
        type: FIELD_TYPES.TEXT,
        label: "Sales Tab Tagline",
        translatable: true
    },
    salesUsecase1: {
        type: FIELD_TYPES.TEXT,
        label: "Sales Usecase 1",
        translatable: true
    },
    salesUsecase2: {
        type: FIELD_TYPES.TEXT,
        label: "Sales Usecase 2",
        translatable: true
    },
    salesUsecase3: {
        type: FIELD_TYPES.TEXT,
        label: "Sales Usecase 3",
        translatable: true
    },
    salesUsecase4: {
        type: FIELD_TYPES.TEXT,
        label: "Sales Usecase 4",
        translatable: true
    },
    salesUsecase5: {
        type: FIELD_TYPES.TEXT,
        label: "Sales Usecase 5",
        translatable: true
    },
    salesUsecase6: {
        type: FIELD_TYPES.TEXT,
        label: "Sales Usecase 6",
        translatable: true
    },
    sectionSubtitle: {
        type: FIELD_TYPES.TEXT,
        label: "Section Subtitle",
        translatable: true
    },
    sectionTitle: {
        type: FIELD_TYPES.TEXT,
        label: "Section Title",
        translatable: true
    }
};
